import React, { useState } from "react";
import { Checkbox, Typography, Form, Empty } from "antd";
import { CalendarOutlined, UploadOutlined } from "@ant-design/icons";
import { formatDateByType } from "../../../libs/utils";
import { AddRemarks } from "./addRemark";
import { Popup } from "../../../atoms/Popup";
import { useGetChecklistData } from "../hooks/useGetCheckLists";
import { useUpdateCheckListItem } from "../hooks/useUpdateCheckListItem";
import { SectionLoader } from "../../../atoms/SectionLoader/SectionLoader";

const { Text, Title } = Typography;

const Checklist = ({ isVisible }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<any>(null);
  const [form] = Form.useForm();

  const { checklist, loading, setChecklist } = useGetChecklistData(isVisible);
  const { updateChecklistItem } = useUpdateCheckListItem({
    checklist,
    setChecklist,
  });

  const getIcon = (type?: "calendar" | "upload") => {
    if (type === "calendar") return <CalendarOutlined />;
    if (type === "upload") return <UploadOutlined />;
    return null;
  };

  const onModalClosed = () => {
    setIsModalOpen(false);
    let updated = checklist.map((t) => (t._id === selectedTask._id ? { ...t, status: "pending" } : t));
    setChecklist(updated);
  };

  const handleOpenModal = (task: any) => {
    setSelectedTask(task);
    setIsModalOpen(true);
    let updated = checklist.map((t) => (t._id === task._id ? { ...t, status: "completed" } : t));
    updated && setChecklist(updated);
  };

  /** ✅ Submit remarks and mark task as completed */
  const handleCompleteSubmit = async () => {
    try {
      const { remarks } = await form.validateFields();
      if (!selectedTask) return;
      const updated = await updateChecklistItem(selectedTask, remarks, true);
      setIsModalOpen(false);
      form.resetFields();
      setSelectedTask(null);
    } catch (err) {
      console.log("Form validation failed", err);
    }
  };

  const popupList = [
    {
      title: (
        <Title level={3} className="m-0">
          Add Remarks
        </Title>
      ),
      content: <AddRemarks form={form} onToggle={onModalClosed} submitData={handleCompleteSubmit} />,
      width: 600,
      style: { padding: "0px" },
    },
  ];

  const popupProps = {
    closable: true,
    visibility: isModalOpen,
    title: popupList[0]?.title,
    content: popupList[0]?.content,
    width: popupList[0]?.width,
    style: popupList[0]?.style,
    onCancel: () => setIsModalOpen(false),
  };

  //  *******************************************************
  //  some Ui section are comment which will use in new design
  // *********************************************************

  // useEffect(() => {
  //   checkListStatus && setCheckListStatus(checkListStatus);
  // }, []);
  return (
    // <Card
    //   style={{
    //     borderRadius: 10,
    //     border: "1px solid #D9EAFD",
    //     overflow: "hidden",
    //   }}
    //   bodyStyle={{ padding: 0 }}
    // >
    //   <Collapse defaultActiveKey={["1"]} bordered={false} expandIconPosition="end">
    // <Panel
    //   header={
    //     <Title level={5} style={{ margin: 0, color: "#004B80" }}>
    //       Checklist
    //     </Title>
    //   }
    //   key="1"
    //   style={{
    //     backgroundColor: "#fff",
    //     border: "none",
    //   }}
    // >
    <SectionLoader isLoading={loading} containerStyle={{ height: "26rem" }}>
      {checklist?.length ? (
        checklist.map((item, idx) => (
          <div
            key={item._id + item?.status}
            style={{
              ...(idx < checklist.length - 1 ? { borderBottom: "1px solid #D9EAFD" } : {}),
              padding: 24,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            {/* <Space direction="vertical"> */}
            <Checkbox
              checked={item?.status === "completed"}
              disabled={item?.status === "completed" || item.completionType === "auto"}
              onChange={() => {
                // ✅ Optimistically mark as completed

                // ✅ Open modal if it's a manual task
                if (item.completionType === "manual" && item?.status !== "completed") {
                  handleOpenModal(item);
                }
              }}
            >
              <Text style={{ color: "#000", fontSize: 14 }}>{item.taskName}</Text>
            </Checkbox>

            <div>
              {item.remarks && <p style={{ marginBottom: "0.25rem" }}>Remarks: {item.remarks}</p>}

              {(item?.completionDate || item?.updatedBy) && (
                <p style={{ margin: "0", color: "var(--blue-600)", fontSize: 12 }}>
                  {item?.completionDate && <span>{formatDateByType(item?.completionDate, "datetime")}</span>}

                  {item?.updatedBy && (
                    <>
                      <span>{` by `}</span>
                      <span style={{ fontWeight: 700 }}>{item?.updatedBy}</span>
                    </>
                  )}
                </p>
              )}
            </div>
            {/* <div style={{ display: "flex" }}>
              <Tag style={{ lineHeight: "1px" }} color={item.status === "completed" ? "green" : "orange"}>
                {item.status.toUpperCase()}
              </Tag>
              {item?.completionType && (
                <Tag style={{ lineHeight: "1px" }} color={item.completionType === "auto" ? "purple" : "blue"}>
                  {item.completionType.toUpperCase()}
                </Tag>
              )}
            </div>

            {item.remarks && (
              <div>
                <Text type="secondary">Remarks: {item.remarks}</Text>
              </div>
            )}

            {item.completionDate && (
              <div>
                <Text type="secondary">Completed on: {formatDate(item.completionDate).toLocaleString()}</Text>
              </div>
            )} */}

            {/* </Space> */}

            {/* {
          item.iconType && (
            <Tooltip title={item.itemName}>
              <div
                style={{
                  backgroundColor: "#004B80",
                  borderRadius: 6,
                  width: 28,
                  height: 28,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#fff",
                  fontSize: 14,
                }}
              >
                {getIcon(item.iconType)}
              </div>
            </Tooltip>
          )} */}
          </div>
        ))
      ) : (
        <Empty style={{ height: "26rem", display: "flex", flexDirection: "column", justifyContent: "center" }} />
      )}

      {/* ✅ Modal for Manual Completion */}

      <Popup destroyOnClose={true} {...popupProps} onCancel={() => onModalClosed()} />
    </SectionLoader>
    // </Panel>
    //   </Collapse>
    // </Card>
  );
};

export default Checklist;
